// components/layouts/PageContainer.tsx

import { ReactNode, useEffect, useState } from "react";

interface PageContainerProps {
  children: ReactNode;
  className?: string;
  withContainer?: boolean;
}

export function PageContainer({ children, className = "", withContainer = false }: PageContainerProps) {
  const [headerHeight, setHeaderHeight] = useState(0);

  useEffect(() => {
    const header = document.querySelector("header");
    if (header) {
      setHeaderHeight(header.offsetHeight-40);
    }

    const resizeObserver = new ResizeObserver((entries) => {
      for (const entry of entries) {
        setHeaderHeight(entry.contentRect.height-40);
      }
    });

    if (header) {
      resizeObserver.observe(header);
    }

    return () => resizeObserver.disconnect();
  }, []);

  return (
    <div className={`min-h-screen ${className}`} style={{ paddingTop: headerHeight }}>
      {withContainer ? (
        <div className="container mx-auto px-4 md:px-6">{children}</div>
      ) : (
        children
      )}
    </div>
  );
}